function isLoggedInUser() {
    return fetch('https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails', {
            method: 'GET',
            headers: { 'Accept': 'application/json' },
            credentials: 'include',
            cache: 'no-store'
        })
        .then((httpResponse) => {
            if (httpResponse.ok) {
                return httpResponse.json();
            }
            throw new Error("Fetch did not succeed");
        })
        .then((json) => {
            if (json.success && json.payload && json.payload.guid) {
                return true;
            }
            return false;
        })
        .catch((err) => {
            console.error("Error while fetching user details:", err.message);
            throw err; // Rethrow the error for the caller to handle
        });
}

class GoogleOT extends HTMLElement {
    constructor() {
        super();
        window.handleCredentialResponse = (response) => {
            const redirectUrl = encodeURIComponent('https://manage.wix.com/logo/maker/esh/');

            let url;
            if (window.props?.studio) {
                url = `https://users.wix.com/signin?studio=true#state=googleOT&id_token=${response.credential}`;
            } else if (window.props?.logo) {
                url = url = `https://users.wix.com/signin?color=LOGO&redirectTo=${redirectUrl}#state=googleOT&id_token=${response.credential}`;
            } else {
                url = `https://users.wix.com/signin#state=googleOT&id_token=${response.credential}`;
            }
            window.location = url;
        }

        window.cacheKillerCounter = 0;
    }

    connectedCallback() {

    }

    async attributeChangedCallback(name, oldValue, newValue) {
        if (name == "props") {
            window.props = JSON.parse(newValue);
            const formFactor = window.props.formFactor;
            const isIncluded = window.props.includedCountryCode.find((code) => code == window.props.userCountryCode);
            if (window.props && window.props[formFactor] && ((formFactor === 'Mobile' && isIncluded) || formFactor !== "Mobile")) {
                try {
                    const isLoggedIn = await isLoggedInUser();
                    if (!isLoggedIn) {
                        console.log({ GOT: true, formFactor, userCountryCode: window.props.userCountryCode });
                        this.addGoogleOneTapScript();
                    }
                } catch (err) {
                    console.error("Error while checking user login status:", err.message);
                }
            }
        }
    }

    addGoogleOneTapScript() {
        let googleOTScript = document.createElement('script');

        googleOTScript.setAttribute('src', 'https://accounts.google.com/gsi/client');
        googleOTScript.setAttribute('async', '');

        document.head.appendChild(googleOTScript);

        let container = document.createElement('div');

        container.setAttribute('id', 'g_id_onload');
        container.setAttribute('data-client_id', '352188552355.apps.googleusercontent.com');
        container.setAttribute('data-callback', 'handleCredentialResponse');
        container.setAttribute('data-cancel_on_tap_outside', 'false');
        container.setAttribute('data-prompt_parent_id', 'g_id_onload');

        document.body.appendChild(container);

        this.fetchModalLoad();
    }

    fetchModalLoad() {
        const body = '&' + encodeURIComponent('app_url=wix.com');

        fetch(`https://frog.wix.com/hls2?src=6&evid=186&app_url=wix.com&_=${this.getCacheKiller()}`, {
            method: 'post',
            mode: 'no-cors',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body
        });
    }

    getCacheKiller() {
        return new Date().getTime() + window.cacheKillerCounter++;
    }

    static get observedAttributes() {
        return ['props'];
    }
}

customElements.define('google-one-tap', GoogleOT);

// function isLoggedInUser() {
//     return fetch('https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails', {
//             method: 'GET',
//             headers: { 'Accept': 'application/json' },
//             credentials: 'include',
//             cache: 'no-store'
//         }).then((httpResponse) => {
//             if (httpResponse.ok) {
//                 return httpResponse.json();
//             }
//             return Promise.reject("Fetch did not succeed");
//         })
//         .then((json) => {
//             if (json.success && json.payload && json.payload.guid) {
//                 return true;
//             }
//             return false;
//         })
//         .catch((err) => {
//             console.error("could not get user details");
//         });
// }

// class GoogleOT extends HTMLElement {
//     constructor() {
//         super();
//         window.handleCredentialResponse = (response) => {
//             let url;
//             if (window.props?.studio) {
//                 url = `https://users.wix.com/signin?studio=true#state=googleOT&id_token=${response.credential}`;
//             } else {
//                 url = `https://users.wix.com/signin#state=googleOT&id_token=${response.credential}`;
//             }
//             window.location = url;
//         }
//     }

//     connectedCallback() {

//     }

//     attributeChangedCallback(name, oldValue, newValue) {
//         if (name == "props") {
//             console.log({newValue});
//             window.props = JSON.parse(newValue);
//             if (window.props && window.props[window.props.formFactor]) {
//                 isLoggedInUser().then((isLoggedIn) => {
//                     if (isLoggedIn) {
//                         return;
//                     } else {

//                         let googleOTScript = document.createElement('script');

//                         googleOTScript.setAttribute('src', 'https://accounts.google.com/gsi/client');
//                         googleOTScript.setAttribute('async', '');

//                         document.head.appendChild(googleOTScript);

//                         let container = document.createElement('div');

//                         container.setAttribute('id', 'g_id_onload');
//                         container.setAttribute('data-client_id', '352188552355.apps.googleusercontent.com');
//                         container.setAttribute('data-callback', 'handleCredentialResponse');
//                         container.setAttribute('data-cancel_on_tap_outside', 'false');
//                         container.setAttribute('data-prompt_parent_id', 'g_id_onload');
//                         if (window.props?.sticky) {
//                             container.setAttribute('style', 'position: fixed;right:400px;top: 68px;width: 0;height: 0; marginTop: 50px');
//                         } else {
//                             container.setAttribute('style', 'position: absolute ;right:400px;top:55px;width:0;height:0; marginTop: 50px');
//                         }

//                         document.body.appendChild(container);
//                     }
//                 })
//             }
//         }
//     }

//     static get observedAttributes() {
//         return ['props'];
//     }
// }

// customElements.define('google-one-tap', GoogleOT);

// // class GoogleOT extends HTMLElement {
// //     constructor() {
// //         super();
// //     }

// //     connectedCallback() {
// //         let googleOTScript = document.createElement('script');
// //         googleOTScript.setAttribute('src', 'https://accounts.google.com/gsi/client');
// //         googleOTScript.setAttribute('defer', '');
// //         document.head.appendChild(googleOTScript);
// //         let container = document.createElement('div');
// //         container.setAttribute('id', 'g_id_onload');
// //         container.setAttribute('data-prompt_parent_id', 'g_id_onload');
// //         container.setAttribute('data-client_id', '352188552355.apps.googleusercontent.com');
// //         container.setAttribute('style', 'position: absolute ;right:400px;top:55px;width:0;height:0;')
// //         document.body.appendChild(container);

// //         let cacheKillerCounter = 0;

// //         function getCacheKiller() {
// //             return new Date().getTime() + cacheKillerCounter++;
// //         }
// //         const body = '&' + encodeURIComponent('app_url=wix.com');

// //         function handleCredentialResponse(response) {
// //             const url = `https://users.wix.com/signin#state=googleOT&id_token=${response.credential}`;
// //             window.location = url;
// //         }

// //         googleOTScript.onload = function () {
// //             google.accounts.id.initialize({
// //                 client_id: '352188552355.apps.googleusercontent.com',
// //                 callback: handleCredentialResponse,
// //                 cancel_on_tap_outside: false,
// //                 context: 'signup',
// //                 prompt_parent_id: 'g_id_onload'
// //             });
// //             google.accounts.id.prompt((notification) => {
// //                 if (notification.isDisplayed()) {
// //                     fetch(`https://frog.wix.com/hls2?src=6&evid=186&app_url=wix.com&_=${getCacheKiller()}`, {
// //                         method: 'post',
// //                         mode: 'no-cors',
// //                         credentials: 'include',
// //                         headers: {
// //                             'Content-Type': 'application/x-www-form-urlencoded'
// //                         },
// //                         body
// //                     });
// //                 }
// //             });
// //         }
// //     }
// // }

// // customElements.define('google-one-tap', GoogleOT);